/**
 * 浏览器安全上下文判断（地理位置等 API 需要）
 * - https:// 任意域名：可用
 * - http://localhost / 127.0.0.1：可用
 * - http://内网IP / 自定义域名：不可用（必须 HTTPS）
 */
export function isSecureGeolocationContext() {
  if (typeof window === 'undefined') return false;
  if (typeof window.isSecureContext === 'boolean') {
    return window.isSecureContext;
  }
  const { protocol, hostname } = window.location;
  if (protocol === 'https:') return true;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getGeolocationHttpsHint() {
  return '地理位置功能需要在 HTTPS 环境下使用。本机请用 https://localhost:3000 ，或通过 scripts\\start-local-gateway.bat 用 https://内网IP/ 访问。';
}
